module.exports = __webpack_public_path__ + "img/contact-type-ct.e83cb958.png";